import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Injectable } from '@angular/core';
import { AbstractLmtActivityService } from '../abstraction/abstract.lmt-activity.service';
import { ITableServerResponseFilter } from '../../../common/interfaces/table/table-server-filter-response.interface';
import { ITableServerFilter } from '../../../common/interfaces/table/table-server-filter.inteface';

@Injectable({
  providedIn: 'root',
})
export class LmtActivityService extends AbstractLmtActivityService {
  controller = `/manager/rtp/lmttransactions`;
  urlGetLmtGrid = `${environment.apiUrl}${this.controller}/grid`;
  urlGetLmtExportExcel = `${environment.apiUrl}${this.controller}/gridExportExcel`;
  urlGetLmtExportCSV = `${environment.apiUrl}${this.controller}/gridExportCSV`;

  override tableFilter(
    filter: ITableServerFilter
  ): Promise<ITableServerResponseFilter | undefined> {
    return this.http.post<ITableServerResponseFilter>(`${this.urlGetLmtGrid}`, filter).toPromise();
  }
  override tableExportCSV(filter: ITableServerFilter): Promise<Blob | undefined> {
    return this.http
      .post(`${this.urlGetLmtExportCSV}`, filter, {
        responseType: 'blob',
      })
      .toPromise();
  }
  override tableExportExcel(filter: ITableServerFilter): Promise<any> {
    return this.http.post(`${this.urlGetLmtExportExcel}`, filter).toPromise();
  }
  constructor(private http: HttpClient) {
    super();
  }
}
